export const FEEDBACKS_FETCH_ERROR = 'Ошибка при получении отзывов:';
